import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-12" }
const _hoisted_4 = { class: "banner-content text-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "job-listing-area pt-120 mb-120" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Your Account Verified. Please login"),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("a", { href: "" }, "Login")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "inner-banner",
      style: _normalizeStyle(_ctx.bgImage)
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", {
                style: _normalizeStyle(_ctx.textColor)
              }, "Account Verification", 4),
              _hoisted_5
            ])
          ])
        ])
      ])
    ], 4),
    _hoisted_6
  ]))
}